<template>
  <list-table
    :url="url"
    title="لیست انتقال وجه داخلی"
    :params="params"
    :fields="fields"
    :btns="btns"
    
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  CONFIRM_INTERNAL_TRANSFER,
  REJECT_INTERNAL_TRANSFER,
} from "@/core/services/store/internalTransfer.module";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";
export default {
  name: "internalTransfer",
  data() {
    return {
     
      url: "internal_transfer",
      fields: [
        {
          key: "id",
          label: "کد درخواست",
        },
        {
          key: "sender_website",
          label: "وبسایت مبدا",
        },
        {
          key: "reciver_website",
          label: "وبسایت مقصد",
        },
        {
          key: "amount",
          label: "مبلغ",
          formatter(value, key, item) {
            return value.toLocaleString();
          },
        },

        {
          key: "status",
          label: "وضعیت",
          formatter(value, key, item) {
            var state = item.tracking_number;
            return state !== null ? "بررسی شده" : "بررسی نشده";
          },
          tdClass(value, key, item) {
            var state = item.tracking_number;
            return state !== null ? "text-success" : "text-danger";
          },
        },
        {
          key: "tracking_number",
          label: "نتیجه عملیات",
        },
        {
          key: "btns",
          label: "عملیات",
        },
      ],
      params: [],
      btns: [
        {
          icon: "x-circle",
          class: "text-danger",
          title: "رد انتقال",
          handler: (t) => {
            t.tracking_number==null ? 
            this.$store
              .dispatch(REJECT_INTERNAL_TRANSFER, t.id)
              .then((data) => {
                if (data.success) {
                   this.url = "internal_transfer?t=" + new Date().getTime();
                  this.$makeToast(
                    "success",
                    "عملیات موفق",
                    `لغو انتقال شما با موفقیت انجام شد.`,
                    5000
                  );
                } else {
                  this.$makeToast(
                    "danger",
                    "خطای سمت سرور",
                    "لطفا مجددا تلاش نمایید.",
                    5000
                  );
                }
                
              }) : 
              this.$makeToast(
                    "danger",
                    "خطای ارسال مجدد",
                    "درخواست قبلا ارسال گردیده است.لطفا مجددا تلاش نکنید.",
                    5000
                  );
          },
        },
        {
          icon: "check2-circle",
          title: "تایید انتقال",
          handler: (t) => {
            t.tracking_number==null ? 
            this.$store
              .dispatch(CONFIRM_INTERNAL_TRANSFER, t.id)
              .then((data) => {
                if (data.success) {
                    this.url = "internal_transfer?t=" + new Date().getTime();
                  this.$makeToast(
                    "success",
                    "عملیات موفق",
                    `درخواست انتقال شما با موفقیت انجام شد.`,
                    5000
                  );
                } else {
                  this.$makeToast(
                    "danger",
                    "خطای سمت سرور",
                    "لطفا مجددا تلاش نمایید.",
                    5000
                  );
                }
                
              }): 
              this.$makeToast(
                    "danger",
                    "خطای ارسال مجدد",
                    "درخواست قبلا ارسال گردیده است.لطفا مجددا تلاش نکنید.",
                    5000
                  );
          },
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "انتقال وجه داخلی" }]);
  },
  components: {
    "list-table": TableShowData,
  },
};
</script>